import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  alarmResponseStaleMinutes,
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../global.variable';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '../../app.service';
import { ModalDialogueService } from '../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { SitesService } from '../sites/sites.service';
import { JobsService } from '../../pages/pages/jobs/jobs.service';
import { firstValueFrom } from 'rxjs';
import { ClientsService } from '../../pages/pages/clients/clients.service';

@Component({
  selector: 'gtapp-jobs',
  standalone: false,
  templateUrl: './jobs.component.html',
  styleUrl: './jobs.component.scss',
})
export class JobsComponent implements OnInit, OnDestroy {
  @Input() clientData: any = {};
  @Input() siteData: any = {};

  jobSearchString: string = '';

  previousJobs: number = 0;
  rowsJobs: number =
    this.appService.getUserData()?.preferences?.job_page_size || 10;
  pageNumJobs: number = 1;
  totalPagesJobs: number = 0;
  sortKeyJobs: any = '-modified_date';
  searchParamsJobs: any;
  totalJobCount: number = 0;

  jobPaginationData: any = {};

  jobDetailsTableView: any = [];

  jobDropDownList: any = [];

  otherParamsJobs: any = {
    apiFiltering: true,
  };

  largeView: Boolean = isLargeScreen;

  tableStyle = {
    'overflow': 'auto',
    'max-height': this.largeView ? '75vh' : '65vh',
  };

  jobStatusDataList: any = [];

  constructor(
    private siteService: SitesService,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private clientService: ClientsService,
    private jobService: JobsService,
  ) {}

  ngOnDestroy(): void {}
  async ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('clientData')) {
      this.clientData =
        this.route.snapshot.queryParamMap.get('clientData') || {};
    }
    if (this.route.snapshot.queryParamMap.get('siteData')) {
      this.siteData = this.route.snapshot.queryParamMap.get('siteData') || {};
    }

    if (!this.clientData?.id) {
      const primeContractors: any = await this.getPrimeContractor();

      const primeContractor = primeContractors?.[0];

      if (!primeContractor?.id) {
        this.toasterService.setMessage({
          errorMessage: '',
          successMessage: 'Prime Contractor Details Not Found',
        });
        return;
      }
      this.clientData = primeContractor;
    }
    this.formatRouteUrl();
    this.getTableDetails();
    this.getJobStatuses();
  }
  getJobStatuses() {
    this.jobService.getJobParams().subscribe((response: any) => {
      this.jobStatusDataList = response.statuses || [];

      this.jobStatusDataList.push({
        id: '0',
        name: 'Closed',
        additional_info: {
          style: {
            snubbed: {
              'color': 'var(--color-basic-1100)',
              'background-color': 'var(--color-basic-100)',
            },
          },
        },
      });

      this.getJobListData();
    });
  }
  async getPrimeContractor() {
    const response: any = await firstValueFrom(
      this.clientService.fetchCustomerList({ prime_contractors: 1, rows: 1 }),
    );

    return response?.data || [];
  }

  getJobsCount(reqBody: any, reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.siteService.getJobList(reqBody, params).then((response: any) => {
      if (response['status'] == 'success') {
        this.otherParamsJobs = {
          ...this.otherParamsJobs,
          paginationData: {
            totalRows: response?.total_size,
            previousRows: this.previousJobs,
            rows: this.rowsJobs,
            pageNum: this.pageNumJobs,
            totalPages: this.totalPagesJobs,
          },
        };

        this.totalJobCount = response?.jobs_count || 0;
      }
    });
  }

  getJobListData(getCount = true) {
    let params: any = {};
    let statuses: any = [1, 10, 11, 12, 13];
    if (this.clientData?.pc_show_all_jobs) {
      statuses.push(9);
    }
    let reqBody: any = { status_identities: statuses };
    if (this.rowsJobs) {
      params['rows'] = this.rowsJobs;
      let userData = this.appService.getUserData()?.preferences?.job_page_size;
      if (userData?.preferences) {
        userData.preferences.job_page_size = this.rowsJobs;
        this.appService.setUserData(userData);
      }
    }
    if (this.clientData?.id) reqBody.company_id = this.clientData?.id;

    if (this.previousJobs) {
      params['previous'] = this.previousJobs;
    }
    if (this.jobSearchString) {
      params['search_str'] = this.jobSearchString;
    }

    if (this.searchParamsJobs) {
      reqBody['search_filter'] = this.searchParamsJobs;
    }

    if (this.sortKeyJobs) {
      params['sort_key'] = this.sortKeyJobs;
    }

    if (this.jobPaginationData?.[this.pageNumJobs]?.length) return;
    if (getCount) this.getJobsCount(reqBody, params);

    this.spinnerService.show();
    this.siteService.getJobList(reqBody, params).then((response: any) => {
      if (response['status'] == 'success') {
        this.jobPaginationData[this.pageNumJobs] = [...response?.data];
        this.updateRoutPath();

        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
      }
    });
  }
  onChangePaginationJob(data: any) {
    this.previousJobs = data?.paginationData?.previousRows;
    this.pageNumJobs = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsJobs) {
      this.jobPaginationData = {};
    }
    this.rowsJobs = data?.paginationData?.rows;

    this.otherParamsJobs.paginationData = {
      ...data?.paginationData,
    };
    this.getJobListData(false);
  }
  sortColumnJob(body: any) {
    this.sortKeyJobs = body?.sortList || [];
    this.searchParamsJobs = body?.searchParams || {};
    if (body?.site_id) {
      this.searchParamsJobs = {
        ...this.searchParamsJobs,
        site: body?.site_id,
      };
    }
    this.jobSearchString = '';
    this.jobPaginationData = {};
    this.getJobListData(false);
  }
  searchColumnJob(event: any) {
    this.searchParamsJobs = event?.searchParams || {};
    if (event?.site_id) {
      this.searchParamsJobs = {
        ...this.searchParamsJobs,

        site: event?.site_id,
      };
    }
    this.clearValues();
    this.getJobListData();
  }
  clearValues() {
    this.previousJobs = 0;
    this.pageNumJobs = 1;
    this.jobSearchString = '';
    this.jobPaginationData = {};
  }

  onJobLookup(event: any) {
    if (event.target.value.length > 3) {
      let params: any = { search_str: event.target.value };

      this.siteService.getJobList({}, params).then((res: any) => {
        this.jobDropDownList = res?.data || [];
      });
    }
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsJobs,
          otherParams: this.otherParamsJobs,
          jobSearchString: this.jobSearchString,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsJobs = {
          ...this.searchParamsJobs,
          ...(urlFragmentDetails?.searchParams || {}),
        };

        this.jobSearchString = urlFragmentDetails?.jobSearchString || '';
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousJobs =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousJobs;
          this.pageNumJobs =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumJobs;
          this.rowsJobs =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsJobs;
        }
      }
    } catch (error) {}
  }
  getNestedAssignees(rowData: any, maxNumber: any = 2) {
    if (rowData?.assignee?.length > maxNumber) {
      return `${rowData?.assignee?.slice(0, maxNumber)} ...`;
    } else {
      return rowData?.assignee;
    }
  }
  getTableDetails() {
    let tableDetails = this.largeView
      ? [
          {
            tableColumnStyle: {
              'white-space': 'pre-line',
              'vertical-align': 'middle',
            },

            header: 'Date',
            name: 'modified_date',
            datetimeObj: true,
            dateRangeKey: 'modified_date',
            sortKey: 'modified_date',
            conditionalColumnStyle: (row: any) => {
              if ([1, 2, 3, 9, 10, 11, 12, 13].includes(row?.status_identity))
                return { 'vertical-align': 'middle' }; // if job status is complete,closed, cancelled, no need to worry about this
              const isStatusNew =
                row?.status_identity === 0 &&
                row?.status?.toLowerCase() === 'new';

              if (isStatusNew) {
                // check if the status has not been changes in the last 15 minutes then blink it
                const jobCreatedDateTime = new Date(
                  row?.created_date,
                ).getTime();
                const staleDateTime = new Date().getTime() - 1000 * 60 * 15;
                if (jobCreatedDateTime < staleDateTime) {
                  return {
                    'color': 'var(--bs-light)',
                    // 'background-color': 'var(--bs-danger)',
                    'animation-name': 'jobAlert',
                    'animation-duration': '0.25s',
                    'animation-iteration-count': 'infinite',
                    'animation-direction': 'alternate',
                    'vertical-align': 'middle',
                  };
                }
              }

              const modifiedDate = new Date(row?.modified_date).getTime();
              const staleDateTime =
                new Date().getTime() - 1000 * 60 * alarmResponseStaleMinutes;

              if (
                modifiedDate < staleDateTime
                //  if the job has not been updated in the last  this.staleMinutes
              ) {
                return {
                  'color': 'var(--bs-white)',
                  'background-color': 'var(--bs-danger)',
                };
              }
              return { 'vertical-align': 'middle', 'white-space': 'pre-line' };
            },
          },
          {
            header: 'Docket No.',
            searchKey: 'job_key',
            tableColumnStyle: {
              'white-space': 'pre-line',
              'font-size': '0.8rem',
              'vertical-align': 'middle',
            },
            nestedValue: (row: any) => {
              let appendList = [row?.job_key];
              if (row?.ext_job_id) appendList.push(`[${row?.ext_job_id}]`);

              return appendList.join('\n');
            },
          },
          {
            header: 'Job Type',
            name: 'service_type',
            sortKey: 'job_type__name',
            searchKey: 'job_type__name',
            tableColumnStyle: {
              'white-space': 'pre-line',
              'vertical-align': 'middle',
            },
            suffixNestedValue: (row: any) => {
              const job_type = row?.response_type || row?.job_service_type;
              let typeList: any = [''];
              if (job_type) typeList.push(job_type);
              if (row?.monitoring_company)
                typeList.push(`[${row?.monitoring_company}]`);
              return typeList?.join('\n');
            },
            suffixStyle: { 'font-size': 'small' },
          },
          {
            header: 'Site',
            name: 'site_name',
            searchKey: 'site_name',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            suffixNestedValue: (row: any) => {
              return '\n' + row?.sites;
              // return `\n[${row?.company}]` + '\n' + row?.sites;
            },
            suffixStyle: { 'font-size': '0.8rem' },
            autoComplete: 'site',
            autoCompleteFilter: { company_id: this.clientData?.id },
          },
          // {
          //   header: 'Guard',
          //   name: 'assignee',
          //   nestedValue: (row: any) => {
          //     return this.getNestedAssignees(row);
          //   },
          //   tableColumnStyle: {
          //     'white-space': 'pre-line',
          //     'vertical-align': 'middle',
          //   },

          //   searchKey: 'assignee',
          //   autoComplete: 'user',
          // },
          // {
          //   header: 'Status',

          //   tableColumnStyle: {
          //     'white-space': 'pre-line',
          //     'vertical-align': 'middle',
          //   },

          //   nestedValue: (row: any) => {
          //     let appendList = [];
          //     if (row?.status) appendList.push(row?.status);
          //     if (row?.guard_eta && Number(row?.guard_eta) > 0)
          //       appendList.push(this.getEtaValue(row));

          //     return appendList.join('\n');
          //   },
          //   conditionalColumnStyle: (row: any) => {
          //     return this.getJobStatusStyle(row, true);
          //   },
          //   // dropDownList: () => {
          //   //   return this.jobStatusDataList?.filter((status: any) =>
          //   //     [1, 9].includes(status?.status_identity?.value),
          //   //   );
          //   // },

          //   // dropdownKey: 'status_id',
          // },
        ]
      : [
          {
            name: 'site_name',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            searchKey: 'site_name',
            sortKey: 'site_name',
            autoComplete: 'site',
            autoCompleteFilter: { company_id: this.clientData?.id },
            prefixNestedValue: (row: any) => {
              const appendList: any = [];

              let jobType: string = row?.service_type;
              const job_type = row?.response_type || row?.job_service_type;
              if (job_type) jobType += `[${job_type}]`;

              if (jobType) appendList.push(jobType);

              let jobKey: string = row?.job_key;
              if (row?.ext_job_id) jobKey += `[${row?.ext_job_id}]`;
              appendList.push(jobKey);
              if (appendList?.length) appendList.push('');
              return appendList?.join('\n');
            },
            columnDataStyle: { 'font-weight': 'bold' },

            suffixNestedValue: (row: any) => {
              const appendList: any = ['', row?.sites];
              if (row?.monitoring_company)
                appendList.push(`[${row?.monitoring_company}]`);

              // const assignees = this.getNestedAssignees(row);

              // if (assignees) appendList.push(assignees);

              return appendList?.join('\n');
            },
          },
          // {
          //   tableColumnStyle: {
          //     'vertical-align': 'top',
          //   },

          //   nestedValue: (row: any) => {
          //     let appendList = [];
          //     if (row?.status) appendList.push(row?.status);
          //     if (row?.guard_eta && Number(row?.guard_eta) > 0)
          //       appendList.push(this.getEtaValue(row));

          //     return appendList.join('\n');
          //   },

          //   conditionalColumnDataStyle: (row: any) => {
          //     return this.getJobStatusStyle(row, false);
          //   },
          // },
        ];

    updateCustomTableHeaders(tableDetails, this.searchParamsJobs);

    this.jobDetailsTableView = [...tableDetails];
  }
  getJobStatusStyle(jobData: any, isLargeView = false) {
    let customStyle: any = {};
    let additionalStyle: any = {};
    if (
      jobData?.guard_eta &&
      Number(jobData?.guard_eta) > 0 &&
      jobData?.type_identity === 0
    ) {
      //https://app.shortcut.com/sendem/story/9210/highlight-repsonse-jobs-with-eta-beyond-80-40-day-night-minutes-from-response-creation-time
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const totalMinutes = hours * 60 + minutes;
      const isItDay = totalMinutes >= 6 * 60 && totalMinutes < 18 * 60;

      const createdDate = new Date(jobData?.created_date).getTime();

      const highlightJob =
        (jobData?.guard_eta - createdDate) / 60000 > (isItDay ? 80 : 40);
      if (highlightJob) {
        additionalStyle = {
          'animation-name': 'jobAlert',
          'animation-duration': '0.25s',
          'animation-iteration-count': 'infinite',
          'animation-direction': 'alternate',
        };
      }
    }

    if (isLargeView) {
      this.jobStatusDataList?.forEach((element: any) => {
        if (element.name === jobData?.status) {
          customStyle = {
            'color': `${element.additional_info?.style?.snubbed?.color}`,
            'background-color': `${element.additional_info?.style?.snubbed['background-color']}`,
            'text-align': 'center',
            'white-space': 'pre-line',
            'vertical-align': 'middle',
            ...additionalStyle,
          };
        }
      });
    } else {
      this.jobStatusDataList?.forEach((element: any) => {
        if (element.name === jobData?.status) {
          customStyle = {
            'color': `${element.additional_info?.style?.snubbed?.color}`,
            'background-color': `${element.additional_info?.style?.snubbed['background-color']}`,
            'border': '1px solid',
            'border-radius': '5px',
            'padding': '0 0.5rem',
            'float': 'right',
            'font-size': 'small',
            'text-align': 'center',
            'white-space': 'pre-line',
            ...additionalStyle,
          };
        }
      });
    }
    if (jobData?.guard_eta > 0) {
      const diffInTime = jobData?.guard_eta - new Date().getTime();
      if (diffInTime < 0) {
        // this implies that eta provided by user has passed and he is late
        customStyle['background-color'] = 'var(--bs-danger)';
      }
    }

    return customStyle;
  }
  getEtaValue(jobData: any) {
    // if (this.etaSwitch) {
    //   return `ETA: ${formatDateTimeStamp(
    //     jobData?.guard_eta,
    //     'h:mm a',
    //     'en_US',
    //   )} `;
    // } else {
    const diffInTime = jobData?.guard_eta - new Date().getTime();

    const diffInMinutes = Math.floor(diffInTime / (1000 * 60)) + 1;
    return diffInTime >= 0
      ? `${diffInMinutes} minutes`
      : `${diffInMinutes * -1} mins late`;
  }
  // }
  openJobView(job: any) {
    this.router.navigate(['/pc/preview-docket'], {
      queryParams: { jobId: String(job?.id) },
    });
  }
}
